import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfigurationReportTab from './configurationTab';
import Sorting from '../../components/company_panel/common/sorting';
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formateDate, formateDateWithMonth, formateDateWithTime, formatToTwoDecimals, getBrandId, getCompany, getOutletId, showPrice, getExcelColumnWidths } from '../../helpers/commonFunctions';
import CustomPagination from '../../components/company_panel/common/custompagination';
import Loader from '../../components/company_panel/common/loader';
import notFound from '../../../src/assets/company/img/no-record-found.png'
import CustomRangepicker from '../../components/company_panel/common/rangepicker';
import StatusFilter from '../../components/company_panel/common/statusFilter';
import { LOADER_TIME, showFilterlist } from '../../utils/Constants';
import { ListItemCostCalculationReport } from '../../services/company_panel/report.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { lastBusinessDate } from '../../services/company_panel/outletService';
import Swal from 'sweetalert2';
import GlobalLoader from '../../components/company_panel/common/globalLoader';


const ItemCostList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    const [list, setList] = useState([])
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);
    const [businessDate, setBusinessDate] = useState({});

    const [dateFilterValue, setDateFilterValue] = useState([]);
    const [businessDateFilterValue, setBusinessDateFilterValue] = useState([]);
    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        })
    });

    useEffect(() => {
        if (search) {
            setLoader(true)
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('company_id', getCompany().company_id);
            formData.append('brand_id', getBrandId());
            formData.append('outlet_id', getOutletId());
            ListItemCostCalculationReport(formData).then(data => {
                setDataLength(data?.data?.response?.count || 0);
                setList(data?.data?.response?.rows || [])
                setTimeout(() => {
                    setLoader(false)
                }, LOADER_TIME);
            }).catch(error => {
                setList([]);
                setDataLength(0);
                setTimeout(() => {
                    setLoader(false)
                }, LOADER_TIME);
                Swal.fire({
                    customClass: 'swal-wide',
                    position: 'absolute',
                    icon: 'error',
                    title: error?.response?.data?.errors?.message || error?.message,
                    showConfirmButton: false,
                    timer: 1000,
                    toast: true,
                    position: 'top-right',
                })
                console.log("error ====> ", error);
            })
        }

    }, [sorting, search, globalSearch, page, isBrandChanged, isOutletChanged])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }


        if (key == 'business_date') {
            setDateFilterValue([]);
            delete sr['created'];
        } else if (key == 'created') {
            setBusinessDateFilterValue([])
            delete sr['business_date'];
        }
        setSearch(sr);
    }

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        prepareSearch()
        setSearch({})
        setResetDate(!resetdate)
        // $("#defaultstatus")[0].selectedIndex = 0
    }

    const headerMapping = {
        "business_date": "Business Date",
        "brand": "Brand",
        "area": "Area",
        "store_short_code": "Store Short Code",
        "outlet_name": "Outlet",
        "segment": "Segment",
        "aggregator": "Aggregator",
        "item_category": "Category",
        "order_id": "Order ID",
        "item_id": "Item ID",
        "item_name": "Item Name",
        "item_type": "Item Type",
        "item_quantity": "Quantity Sold",
        "item_selling_price": "Selling Price",
        "item_cost_price": "Cost Price",
        "cost_percent": "Cost(%)",
        "item_total_revenue": "Total sales",
        "tax_percent": "Tax(%)",
        "net_sales": "Net Sales",
        "item_total_cost": "Total cost",
        "item_total_profit": "Profit",
        "item_total_profit_margin": "Profit Margin(%)",
    };

    const handleExport = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        formData.append('outlet_id', getOutletId());
        ListItemCostCalculationReport(formData).then(data => {
            setDataLength(data.data.response.count);
            const listData = data && data.data && data.data.response ? data.data.response.rows : [];
            const printData = listData?.map((item) => {
                const transformedItem = {};
                // Extract fields from nested objects
                const businessDate = item?.business_date ? formateDate(item?.business_date) : 'N/A';
                const brand = item?.brand_name || "N/A";
                const area = item?.area_name || "N/A";
                const storeShortCode = item?.outlet_short_code || "N/A";
                const OutletName = item?.outlet_name || 'N/A'
                const segment = item?.order_mode_name || 'N/A'
                const aggregator = item?.aggregator_name || 'N/A'
                const itemCategory = item?.category_name || 'N/A';
                const itemID = item?.entity_id || 'N/A';
                const itemName = item?.item_name || 'N/A';
                const orderID = item?.order_id || 'N/A';
                const itemType = item?.item_type ? capitalizeAllFirstLetters(item.item_type.replace(/_/g, ' ')) : 'N/A';
                const itemQuantitySold = item?.item_quantity || 'N/A';
                const sellingPrice = item?.selling_price || 0;
                const costPrice = item?.item_cost || 0;
                const costPercent = item?.cost_percentage || 'N/A';
                const itemTotalRevenue = item?.net_sales || 0;
                const taxPercent = 15;
                const netSales = item?.net_sales_without_tax || 0;
                const totalCost = item?.item_total_cost || 0;
                const totalProfit = item?.item_total_profit || 0;
                const totalProfitMargin = item?.item_total_profit_margin || 0;

                // Map fields according to headerMapping
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "business_date":
                                transformedItem[newKey] = businessDate;
                                break;
                            case "brand":
                                transformedItem[newKey] = capitalizeFirstLetter(brand);
                                break;
                            case "area":
                                transformedItem[newKey] = capitalizeFirstLetter(area);
                                break;
                            case "store_short_code":
                                transformedItem[newKey] = storeShortCode
                                break;
                            case "outlet_name":
                                transformedItem[newKey] = capitalizeFirstLetter(OutletName)
                                break;
                            case "segment":
                                transformedItem[newKey] = capitalizeFirstLetter(segment)
                                break;
                            case "aggregator":
                                transformedItem[newKey] = capitalizeFirstLetter(aggregator)
                                break;
                            case "item_category":
                                transformedItem[newKey] = capitalizeFirstLetter(itemCategory)
                                break;
                            case "item_id":
                                transformedItem[newKey] = '#' + (itemID);
                                break;
                            case "order_id":
                                transformedItem[newKey] = orderID;
                                break;
                            case "item_type":
                                transformedItem[newKey] = itemType;
                                break;
                            case "item_name":
                                transformedItem[newKey] = capitalizeFirstLetter(itemName);
                                break;
                            case "item_quantity":
                                transformedItem[newKey] = capitalizeFirstLetter(itemQuantitySold);
                                break;
                            case "item_selling_price":
                                transformedItem[newKey] = `${showPrice(sellingPrice)} SAR`;
                                break;
                            case "item_cost_price":
                                transformedItem[newKey] = `${showPrice(costPrice)} SAR`;
                                break;
                            case "cost_percent":
                                transformedItem[newKey] = `${showPrice(costPercent)}`;
                                break;
                            case "item_total_revenue":
                                transformedItem[newKey] = `${showPrice(itemTotalRevenue)} SAR`;
                                break;
                            case "tax_percent":
                                transformedItem[newKey] = `${taxPercent} %`;
                                break;
                            case "net_sales":
                                transformedItem[newKey] = `${showPrice(netSales)} SAR`;
                                break;
                            case "item_total_cost":
                                transformedItem[newKey] = `${showPrice(totalCost)} SAR`;
                                break;
                            case "item_total_profit":
                                transformedItem[newKey] = `${showPrice(totalProfit)} SAR`;
                                break;
                            case "item_total_profit_margin":
                                transformedItem[newKey] = `${formatToTwoDecimals(totalProfitMargin)} %`;
                                break;
                            default:
                                // Handle any unexpected keys
                                console.warn(`Unexpected key in headerMapping: ${key}`);
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'Item-Cost-Report.xlsx');
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            setGlobalLoader(false);
        }).catch(error => {
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };

    useEffect(() => {
        const formData = new FormData();
        formData.append('outlet_id', getOutletId());
        lastBusinessDate(formData).then(data => {
            const fetchedBusinessDates = data?.data?.response || [];
            // const formattedBusinessDate = fetchedBusinessDates.business_date ? new Date(fetchedBusinessDates.business_date).toISOString().split('T')[0] : '';
            const businessDate = new Date(fetchedBusinessDates.business_date);
            const year = businessDate.getFullYear();
            const month = String(businessDate.getMonth() + 1).padStart(2, '0');
            const day = String(businessDate.getDate()).padStart(2, '0');
            const formattedBusinessDate = `${year}-${month}-${day}`;
            
            if (formattedBusinessDate) {
                setBusinessDate(formattedBusinessDate);
            } else {
                setBusinessDate('');
            }
        }).catch(error => {
            console.log("Error fetching business dates:", error);
        });
    }, [isOutletChanged]);

    return (
        <>  
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Report</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                        <button onClick={handleExport} disabled={dataLength === 0} className="btn btn-primary ms-2">Export Report</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <ConfigurationReportTab tab='cost' />
                            </div>
                        </div>
                    </div>
                    {/* <div className='gap-20 ps-0 pb-0 pe-0'>
                        <ul className='d-flex setting submenu-list border-bottom mb-0 p-0'>
                            <li className={taxType === 'Taxes' ? 'active' : ''} onClick={() => { taxConfiguration('Taxes') }}>Taxes</li>
                            <li className={taxType === 'Tax Groups' ? 'active' : ''} onClick={() => { taxConfiguration('Tax Groups') }}>Tax Groups</li>
                        </ul>
                    </div> */}
                    <div className="gap-20">
                        <div className='page-header d-flex align-items-center mb-0'>
                            {/* <div className='page-header-left'></div> */}
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>

                            {/* <div className="date-input">
                                Business Date
                                <CustomRangepicker business_date = {true} value = {businessDateFilterValue} GetDateRange={(e) => { prepareSearch("business_date", e) }} resetdate={resetdate} />
                            </div>
                            <div className="date-input">
                                Date
                                <CustomRangepicker value = {dateFilterValue}  GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                            </div> */}
                            <div className='page-header-right ms-auto d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    Business Date
                                    <CustomRangepicker business_date={true} value={businessDateFilterValue} GetDateRange={(e) => { prepareSearch("business_date", e) }} 
                                    resetdate={resetdate} maxDate={businessDate}  />
                                </div>
                                <div className="date-input">
                                    Date
                                    <CustomRangepicker value={dateFilterValue} GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="%"><span>Business Date</span></th>
                                        <th width="%"><span>Order ID</span></th>
                                        <th width="%"><span>SKU</span></th>
                                        <th width="%"><span>Brand</span></th>
                                        <th width="%"><span>Area</span></th>
                                        <th width="%"><span>Store Short Code</span></th>
                                        <th width="%"><span>Outlet</span></th>
                                        <th width="%"><span>Segment</span></th>
                                        <th width="%"><span>Aggregator</span></th>
                                        <th width="%"><span>Category</span></th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Item ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th>
                                        <th width="%"><span>Item Name</span></th>
                                        <th width="%"><span>Item Type</span></th>
                                        <th className='text-end' width="8%"><span>Quantity sold</span></th>
                                        <th className='text-end' width="%"><span>Selling price</span></th>
                                        <th className='text-end' width="%"><span>Cost price</span></th>
                                        <th className='text-end' width="%"><span>Cost(%)</span></th>
                                        <th className='text-end' width="%"><span>Total sales</span></th>
                                        <th className='text-end' width="%"><span>Total discount</span></th>
                                        <th className='text-end' width="%"><span>Tax(%)</span></th>
                                        <th className='text-end' width="%"><span>Net sales</span></th>
                                        <th className='text-end' width="%"><span>Total cost</span></th>
                                        <th className='text-end' width="%"><span>Profit</span></th>
                                        <th className='text-end' width="10%"><span>Profit Margin (%)</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={24}><Loader /></td>
                                        </tr> : <>
                                            {list?.length ? list.map((row, i) => (
                                                <tr>
                                                    {/* <td>{formateDateWithTime((row?.business_date))}</td> */}
                                                    <td>{formateDateWithMonth((row?.business_date))}</td>
                                                    <td>{row?.order_id ? `#${row?.order_id}` : "-"}</td>
                                                    <td>{row?.item_sku ? row?.item_sku : "-"}</td>
                                                    <td>{row?.brand_name}</td>
                                                    <td>{row?.area_name}</td>
                                                    <td>{row?.outlet_short_code}</td>
                                                    <td>{row?.outlet_name}</td>
                                                    <td>{row?.aggregator_name ? 'Outsource' : row?.order_mode_name}</td>
                                                    <td>{row?.aggregator_name ? row?.aggregator_name : '-'}</td>
                                                    <td>{row?.category_name ? capitalizeFirstLetter(row?.category_name) : "-"}</td>
                                                    <td>#{row?.entity_id}</td>
                                                    <td>{row?.item_name ? capitalizeFirstLetter(row?.item_name) : "-"}</td>
                                                    <td>{row?.item_type ? capitalizeAllFirstLetters(row?.item_type.replace(/_/g, ' ')) : "-"}</td>
                                                    <td className='text-end'>{row?.item_quantity ? Number(row?.item_quantity) : "-"}</td>
                                                    <td className='text-end'>{row?.selling_price ? showPrice(row?.selling_price) : "-"}</td>
                                                    <td className='text-end'>{row?.item_cost ? showPrice(row?.item_cost) : "-"}</td>
                                                    <td className='text-end'>{row?.cost_percentage ? Number(row?.cost_percentage).toFixed(2) : "-"}</td>
                                                    <td className='text-end'>{row?.net_sales ? showPrice(row?.net_sales) : "-"}</td>
                                                    <td className='text-end'>{showPrice(row?.item_total_discount ?? 0)}</td>
                                                    <td className='text-end'>15</td>
                                                    <td className='text-end'>{row?.net_sales_without_tax ? showPrice(row?.net_sales_without_tax) : "-"}</td>
                                                    <td className='text-end'>{row?.item_total_cost ? showPrice(row?.item_total_cost) : "-"}</td>
                                                    {/* <td className='text-end'>{row?.item_total_revenue ? showPrice(row?.item_total_revenue) : "-"}</td> */}
                                                    <td className='text-end'>{row?.item_total_profit ? showPrice(row?.item_total_profit) : "-"}</td>
                                                    <td className='text-end'>{row?.item_total_profit_margin ? showPrice(row?.item_total_profit_margin) : "-"}</td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={24} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No record found</p>
                                                </td>
                                            </tr>
                                            }</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "item-cost-calculation", path: "/company/report/item_cost/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />

            </div>
        </>
    );
}

export default ItemCostList